import { logOutUser } from '../services/AccountApi/louOutApi';
import { toastNotify } from './toastNotify';
import { removeCookie } from './cookies';

export const handleLogOutUser = async () => {
  try {
    const resp = await logOutUser();
    if (!resp.isError) {
      toastNotify('success', resp?.message);
      return true;
    } else {
      toastNotify('error', resp?.message);
      return false;
    }
  } catch (error) {
    const { response } = error;
    toastNotify('error', response?.data?.message);
    return true;
  } finally {
    localStorage.clear();
    removeCookie();
    document.cookie = `user_login=''; path=/; domain=.realbricks.com`;
  }
};
